import httpClient from "../http/http-client";

export default class CreatePdfService {
  http;

  constructor() {
    this.http = httpClient
  }

  async deleteReportPdf(queryString: string): Promise<any> {
    return this.http.get(`pdf/delete${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async makeFinalReportPdf(queryString: string): Promise<any> {
    return this.http.get(`pdf/final${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async createGaiaReportPdf(companyName: string, queryString: string): Promise<any> {
    return this.http.get(`pdf/create/gaia/${companyName}${queryString ? queryString : ''}`, { responseType: 'blob' })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async getSecrReportPdf(queryString: string): Promise<any> {
    return this.http.get(`pdf/create/secr${queryString ? queryString : ''}`, { responseType: 'blob' })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async createProjectReportPdf(companyName: string, queryString: string): Promise<any> {
    return this.http.get(`pdf/create/project-report/${companyName}${queryString ? queryString : ''}`, { responseType: 'blob' })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}